import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Editor } from "@tinymce/tinymce-react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import './style.scss';
import { SEARCH_PROFILE_API } from "../../apiContants";

const AccountProfileDetails = (props) => {
  const { getSelectedData } = props;
  const useForceUpdate = () => useState()[1];
  const fileInput = useRef(null);
  const forceUpdate = useForceUpdate();
  const [reg, regSet] = useState(Array);
  const [value, setValues] = React.useState({
    subject: "",
    content: "",
  });
  const handleChangeForm = (subject) => (event) => {
    setValues({ ...value, [subject]: event.target.value });
  };
  function onSubmit(e) {
    e.preventDefault();
    const data = new FormData(fileInput.current.files);
  }
  const onSubmited = async () => {
    const data = new FormData();
    data.append("upload_file", fileInput.current.files[0]);
    data.append("title", value.subject);
    data.append("content", reg);
    try {
      const uploadPass = await axios.post(SEARCH_PROFILE_API, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } catch {
      console.log("Error loaidng rejected data");
    }
  };
  function onChange(e) {
    regSet(e.target.getContent());
  }

  return (
    <form autoComplete="off" noValidate {...props}>
      <div className="Notice-content">
        <Grid container spacing={3}>
          <Grid item lg={4} md={6} xs={12}>
            <Card {...props}>
              <CardContent>
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    height: 150,
                  }}
                >
                  <div className="App">
                    <form onSubmit={onSubmit}>
                      <input
                        id="file"
                        type="file"
                        ref={fileInput}
                        onChange={forceUpdate}
                        multiple
                      />
                    </form>
                  </div>
                </Box>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
          <Grid item lg={8} md={6} xs={12}>
            <Card>
              <CardHeader
                subheader="The information can be edited"
                title="Notice"
              />
              <Divider />
              <CardContent>
                <TextField
                  fullWidth
                  label="Notice subject"
                  margin="normal"
                  name="password"
                  onChange={handleChangeForm("subject")}
                  // type="password"
                  value={value.password}
                  variant="outlined"
                />
                <Editor
                  initialValue="<p>Notice content</p>"
                  init={{
                    plugins: "link image code",
                    toolbar:
                      "undo redo | bold italic | alignleft aligncenter alignright | code",
                  }}
                  onChange={onChange}
                />
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  p: 2,
                }}
              >
                <Button
                  href="/app/event"
                  className="cancel_button"
                  color="primary"
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => onSubmited()}
                  color="primary"
                  variant="contained"
                >
                  Save details
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

export default AccountProfileDetails;
